<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  watch: {
    '$route'() {
      this.$nextTick(() => {
        window.scrollTo(0, 0)
      })
    }
  }
}
</script>

<style>
html,
body {
  margin: 0;
  padding: 0;
  font-family: 'Microsoft YaHei', '微软雅黑', -apple-system, sans-serif;
  font-size: 14px;
  color: #333;
  background: #fff;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

img {
  border: none;
  max-width: 100%;
  display: block;
}

ul, li {
  list-style: none;
}

a {
  color: #333;
  text-decoration: none;
}
</style>
